import {NonFunctionProperties} from '@colonist/types'
import {BaseRankedUserState, RankedUserStateType} from './BaseRankedUserState'
import {RankedPlacementState} from './RankedPlacementState'
import {RankedMMRState} from './RankedMMRState'
import {RankedLockedState} from './RankedLockedState'

export class RankedUserStateController {
    static deserialize(data: NonFunctionProperties<BaseRankedUserState>): BaseRankedUserState {
        switch(data.type) {
            case RankedUserStateType.Placement: return RankedPlacementState.deserialize(data as NonFunctionProperties<RankedPlacementState>)
            case RankedUserStateType.Ranked: return RankedMMRState.deserialize(data as NonFunctionProperties<RankedMMRState>)
            case RankedUserStateType.RankedLocked: return RankedLockedState.deserialize(data as NonFunctionProperties<RankedLockedState>)
        }
    }
}
